import { PrimaryButton, Spinner, SpinnerSize, Stack, TextField } from "@fluentui/react";
import { CancelIcon } from "@fluentui/react-icons-mdl2";
import { t } from "i18next";
import { useContext, useEffect, useRef, useState } from "react";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import DropdownSelectIcon from "../../../components/SVGComponents/DropdownSelectIcon";
import DropdownUnselectIcon from "../../../components/SVGComponents/DropdownUnselectIcon";
import {
  BORDER,
  CUSTOM_STYLES,
  MODAL_TYPE,
  REPORTED_TABS_NAME,
  SAVED_TABS_NAME,
  TAB_NAME,
  TOAST_TYPE,
  USERTYPES
} from "../../../constants/Constants";
import loaderContext from "../../../context/loader/LoaderContext";
import studylistContext from "../../../context/studylist/StudylistContext";
import toastContext from "../../../context/toast/ToastContext";
import userContext from "../../../context/users/UserContext";
import { getQCProvidersList, reassignQCFix } from "../../../service/StudyReportService";
import { RowBadgeStatic } from "./RadiologistDetails";
import { getEnv } from '../../../helpers/EnvHelper';

const mainStackStyles = {
  // lineHeight: "20px",
  // height: "121px",
  // width: "210px",
  justifyContent: "center",
  marginTop: CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN,
  // transform: "translateY(-39%)"
};

const hospitalStackStyles = {
  fontSize: "14px",
  fontWeight: "400",
  alignItems: "center",
  marginTop: "4px",
};

const reAssignButtonFirmStyle = {
    root: {
      padding: "0px",
      height: "24px",
      width:"30px",
      minWidth:"30px",
      maxWidth:"30px",
      // marginLeft:"10px",
      borderRadius:'7px'
      // marginTop:"6px",
    },
    label:{
      fontSize: "12px",
      fontWeight: "400",
    }
  };

const assignButtonStyle = {
    root: {
      padding: "0px 5px",
      height: "24px",
      width:"60px",
      minWidth:"60px",
      marginLeft:"13px",
      borderRadius:'7px'
    },
    label:{
      fontSize: "12px",
      fontWeight: "400",
    }
  };

const searchInputStyle = {
    root: {
      width: "148px",
     
    },
    field: {
      borderRadius: "7px",
    },
  };

const searchIcon = {
    iconName: "search",
    cursor: "pointer",
    style: { color: "rgba(172, 172, 172, 0.75)"},
  };

const customSpinnerStyle = {
    root:{
      height:"100px"
    },
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

const smallSpinnerStyle = {
  circle: {
    height: "20px",
    width: "20px",
    borderWidth: "3px",
  },
  label: {
    color: "white",
  },
};

const QCDetails = (props) => {
  const { roles, authenticated, loadByUsername, showConfirmation } =
    useContext(userContext);

  const [reassignClick, setReassignClick] = useState(null);
  const [isLoadingAssignment, setIsLoadingAssignment] = useState(false);

  return (
    <>
    {isLoadingAssignment ? 
           <div
           style={{
             display: "flex",
             //flexDirection: "row",
             alignItems: "center",
             flexDirection:'center',
             marginTop:"30px"
           }}
         >
          <Spinner size={SpinnerSize.large} styles={smallSpinnerStyle}/>
          </div>
           :
      <Stack style={mainStackStyles}>
        {props.data.row.depth === 0 && <div>
          {((roles[0] == USERTYPES.SUPERVISOR && props.tabId == TAB_NAME.QCFIX ||
            roles[0] == USERTYPES.FIRMADMIN && props.tabId == TAB_NAME.QCFIX)
            ) && (
              <Stack horizontal style={hospitalStackStyles}>
                {reassignClick == null ? 
                  <AlreadyAssigned
                    data = {props.data}
                    setReassignClick = {setReassignClick}
                  /> :
                  <AssignmentDropDown
                    data={props.data}
                    setReassignClick={setReassignClick}
                    reassignClick={reassignClick}
                    placeholder={t("placeholder.select-provider-radiologist")}
                    isLoadingAssignment = {isLoadingAssignment}
                    setIsLoadingAssignment = {setIsLoadingAssignment}
                  />}
              </Stack>
            )}

{((roles[0] == USERTYPES.SUPERVISOR && (props.tabId === TAB_NAME.QCREVIEW || props.tabId === TAB_NAME.QCREVIEWASSIGNED || props.tabId === TAB_NAME.QCVERIFY || REPORTED_TABS_NAME.includes(props.tabId) || SAVED_TABS_NAME.includes(props.tabId)) &&  (getEnv("REACT_APP_VDC_PLATFORM") !== "true" && getEnv("REACT_APP_BVP_PLATFORM") !== "true"))||
            (roles[0] == USERTYPES.FIRMADMIN && (props.tabId === TAB_NAME.QCREVIEW || props.tabId === TAB_NAME.QCREVIEWASSIGNED || props.tabId === TAB_NAME.QCVERIFY || REPORTED_TABS_NAME.includes(props.tabId) || SAVED_TABS_NAME.includes(props.tabId)) && (getEnv("REACT_APP_VDC_PLATFORM") !== "true" && getEnv("REACT_APP_BVP_PLATFORM") !== "true")))  && (
              <Stack horizontal style={hospitalStackStyles}>
                {/* <span className="study-list-studyDetails-uploaded">Provider Firm :</span> */}
                <RowBadgeStatic name="QR" tooltipText={t("study-list.column.qc-reviewer")} />
                {props.data.row.original.assignmentList[0].qcreviewerId != null &&
                props.data.row.original.assignmentList[0].qcreviewerId.startsWith(
                  "S"
                ) ? (
                  //  <RowBadge name={props.data.row.original.assignmentList[0].providerName} />

                  <span
                    className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                    style={{ width: REPORTED_TABS_NAME.includes(props.tabId) || SAVED_TABS_NAME.includes(props.tabId) ? "110px" : "140px" }}
                  >
                    &nbsp;&nbsp;
                    <CustomToolTipHost
                      content={
                        props.data.row.original.assignmentList[0].qcreviewerName
                      }
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].qcreviewerName
                      }
                    >
                      {props.data.row.original.assignmentList[0].qcreviewerName}{" "}
                    </CustomToolTipHost>
                  </span>
                ) : ((REPORTED_TABS_NAME.includes(props.tabId) || SAVED_TABS_NAME.includes(props.tabId))?
                  <>
                    <span className="study-list-assignment-details-text study-list-row-badge">
                      &nbsp;&nbsp;-
                    </span>
                  </>:
                   <>
                    <span className="study-list-assignment-details-text study-list-row-badge">
                      &nbsp;&nbsp;{t("label.not-assigned")}
                    </span>
                  </>
                )}
              </Stack>
            )}

{(((roles[0] == USERTYPES.SUPERVISOR && (props.tabId === TAB_NAME.QCVERIFY || REPORTED_TABS_NAME.includes(props.tabId) || SAVED_TABS_NAME.includes(props.tabId)) || 
            (roles[0] == USERTYPES.FIRMADMIN && (props.tabId == TAB_NAME.QCVERIFY || REPORTED_TABS_NAME.includes(props.tabId) || SAVED_TABS_NAME.includes(props.tabId)))) &&  (getEnv("REACT_APP_VDC_PLATFORM") !== "true" && getEnv("REACT_APP_BVP_PLATFORM") !== "true") 
           // && (props.tabId == TAB_NAME.QCFIX || props.tabId == TAB_NAME.QCVERIFY)
            )) && (
              <Stack horizontal style={hospitalStackStyles}>
                {/* <span className="study-list-studyDetails-uploaded">Provider Firm :</span> */}
                <RowBadgeStatic name="QV" tooltipText={t("study-list.column.qc-verifier")} />
                {props.data.row.original.assignmentList[0].qcverifierId != null &&
                props.data.row.original.assignmentList[0].qcverifierId.startsWith(
                  "S"
                ) ? (
                  //  <RowBadge name={props.data.row.original.assignmentList[0].providerName} />

                  <span
                    className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                    style={{ width: REPORTED_TABS_NAME.includes(props.tabId) || SAVED_TABS_NAME.includes(props.tabId) ? "110px" : "140px" }}
                  >
                    &nbsp;&nbsp;
                    <CustomToolTipHost
                      content={
                        props.data.row.original.assignmentList[0].qcverifierName
                      }
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].qcverifierName
                      }
                    >
                      {props.data.row.original.assignmentList[0].qcverifierName}{" "}
                    </CustomToolTipHost>
                  </span>
                ) : ((REPORTED_TABS_NAME.includes(props.tabId) || SAVED_TABS_NAME.includes(props.tabId))?
                  <>
                    <span className="study-list-assignment-details-text study-list-row-badge">
                      &nbsp;&nbsp;-
                    </span>
                  </>:
                  <>
                    <span className="study-list-assignment-details-text study-list-row-badge">
                      &nbsp;&nbsp;{t("label.not-assigned")}
                    </span>
                  </>
                )}
              </Stack>
            )}

          {/* <span style={studyUploadDateStyle}>
            {`Uploaded on ${props.data.row.original.uploadDateDisplay}`}
          </span> */}
        </div>}
      </Stack>}
    </>
  );
};

export default QCDetails;

const AlreadyAssigned = (props) => {
  return (
    <>
      <RowBadgeStatic name="QF" tooltipText={t("study-list.column.qc-fixer")} />
      {props.data.row.original.assignmentList[0].qcfixerId != null &&
      (props.data.row.original.assignmentList[0].qcfixerId.startsWith("R") ||
        props.data.row.original.assignmentList[0].qcfixerId.startsWith("F")) ? (
        <>
          {/* <RowBadge name={props.data.row.original.assignmentList[0].providerName} /> */}
          &nbsp;&nbsp;
          <CustomToolTipHost
            content={props.data.row.original.assignmentList[0].qcfixerName}
            id={
              "tooltip_" + props.data.row.original.assignmentList[0].qcfixerName
            }
          >
            <span
              className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
              style={{ width: "100px", display: "block" }}
            >
              {props.data.row.original.assignmentList[0].qcfixerName}{" "}
            </span>
          </CustomToolTipHost>
          {props.data.row.original.assignmentList[0].qcfixerId.startsWith("R") &&
          <div style={{ display: "flex", alignItems: "center" }}>
            <CustomToolTipHost content={t("button.reassign")}>
              <PrimaryButton
                iconProps={{
                  iconName: "Switch",
                  cursor: "pointer",
                }}
                styles={reAssignButtonFirmStyle}
                onClick={() => {
                  props.setReassignClick(true);
                }}
                //disabled={!isActiveData || (props.tabId == TAB_NAME.PENDING || props.tabId == TAB_NAME.APPROVED || props.tabId == TAB_NAME.REJECTED)}
              />
            </CustomToolTipHost>
          </div>}
        </>
      ) : (
        <>
          <span className="study-list-assignment-details-text study-list-row-badge">
            &nbsp;&nbsp;{t("label.not-assigned")}
          </span>
        </>
      )}
    </>
  );
};

export const AssignmentDropDown = (props) => {
  const { isActiveData } = useContext(userContext);
  const { showToastv2, updateToastv2, list, setList } =
    useContext(toastContext);
  const [showDropdownList, setDropdownList] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [selectedKey, setSelectedKey] = useState("");

  const {
    dataQueryState,
    setDataQueryState
  } = useContext(studylistContext);

  const handleOnSelect = (val, key) => {
    console.log(val, key);
    setSelectedItem(val);
    setSelectedKey(key);
  };

  useEffect(() => {
    if (list.length == 0) {
      handleClearSelection();
    }
  }, [list]);

  useEffect(() => {
    if (
      props.reassignClick != null &&
      props.reassignClick != undefined &&
      props.reassignClick
    ) {
      setDropdownList(true);
    }
  }, [props.reassignClick]);

  const handleClearSelection = () => {
    setSelectedItem("");
    setSelectedKey("");
    setDropdownList(false);
  };

  useEffect(() => {
    if (
      props.setHeightIncrease != null &&
      props.setHeightIncrease != undefined
    ) {
      props.setHeightIncrease(showDropdownList);
    }
  }, [showDropdownList]);

  const handleSelection = async () => {
    if (selectedKey == "" || selectedKey == null || selectedKey == undefined){
      showToastv2(TOAST_TYPE.INFO, t("placeholder.select-provider"));
      return;
    }

    if(selectedKey == props.data.row.original.assignmentList[0].qcfixerId){
      showToastv2(TOAST_TYPE.INFO, t("placeholder.select-other-provider"));
      return;
    } 

    const requestData = {
      clientId: props.data.row.original.assignmentList[0].clientId,
      firmId: props.data.row.original.assignmentList[0].firmId,
      studyId: props.data.row.original.id,
      providerId: selectedKey,
    };
    console.log(requestData);
    props.setIsLoadingAssignment(true);
    const response = await reassignQCFix(requestData);
    console.log("--- Data assign ---", response);

    if (response.status === 200 && response.data.result === "SUCCESS") {
      handleUpdateRowForAssign(response.data.data, selectedKey);
      props.setReassignClick(null);
      props.setIsLoadingAssignment(false);
      showToastv2(
        TOAST_TYPE.SUCCESS,
        t("study-list.messages.assign-success-to", { name: response.data.data })
      );
    }else{
      props.setIsLoadingAssignment(false);
      showToastv2(
        TOAST_TYPE.ERROR, response.data.message || "Some Error Occured.");
    }
  };

  const handleUpdateRowForAssign = (name, id) => {
    let newIndex = -1;
    let newData = dataQueryState?.data?.rows.filter((row, index) => {
      if (row.id == props.data.row.original.id) {
        newIndex = index;
        return true;
      }
      return false;
    });
    console.log("dataquerystate", dataQueryState);
    console.log("new data", newData);
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState,
      };
      newValue.data.rows[newIndex].assignmentList[0].qcfixerId = id;
      newValue.data.rows[newIndex].assignmentList[0].qcfixerName = name;
      return newValue;
    });
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <div
          className="custom-dropdown"
          style={{ width: "160px" }}
          onClick={(ev) => {
            ev.stopPropagation();
            setDropdownList((prev) => !prev);
          }}
        >
          <div className="custom-dropdown-title">
            <CustomToolTipHost
              content={selectedItem != "" ? selectedItem : props.placeholder}
              id={"tooltip_"}
            >
              <span
                className="custom-dropdown-placeholder"
                style={{ width: "121px" }}
              >
                {selectedItem != "" ? selectedItem : props.placeholder}
              </span>
            </CustomToolTipHost>

            <div className="custom-dropdown-icon" onClick={(ev)=>{if(selectedItem != ""){ev.stopPropagation();setDropdownList(false);handleClearSelection()}}}>
            {selectedItem == ""?<DropdownSelectIcon />
            :<DropdownUnselectIcon unselectRadiologist = {()=> {}} />}
            </div>
          </div>
          {showDropdownList && (
            <CustomDropDownList
              show={showDropdownList}
              onClickOutside={() => {
                setDropdownList(false);
              }}
              data={props.data}
              handleOnSelect={handleOnSelect}
            />
          )}
        </div>
        <CustomToolTipHost content={t("button.assign")}>
          <PrimaryButton
            // text={t("button.assign")}
            iconProps={{
              iconName: "CheckMark",
              cursor: "pointer",
            }}
            onClick={handleSelection}
            styles={assignButtonStyle}
            disabled={!isActiveData}
          />
        </CustomToolTipHost>
        {props.reassignClick && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            {" "}
            <CancelIcon
              onClick={() => {
                props.setReassignClick(null);
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export const CustomDropDownList = (props) => {
  const [loading, setLoading] = useState(true);
  const [clientProvidersList, setClientProvidersList] = useState([]);
  const [filterValue, setFilter] = useState("");
  const [originalList, setOriginalList] = useState([]);
  const { showModal, setShowModal } = useContext(loaderContext);

  const ref = useRef(null);
  const { onClickOutside } = props;

  useEffect(() => {
    setLoading(true);
    generateClientProviders();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  const generateClientProviders = async () => {
    let tempRadiologistList = [];
    const clientProvidersMapping = {
      clientId: props.data.row.original.assignmentList[0].clientId,
      firmId: props.data.row.original.assignmentList[0].firmId,
      studyId: props.data.row.original.id,
    };
    try {
      setLoading(true);
      const response = await getQCProvidersList(clientProvidersMapping);
      console.log(response);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        if (
          (response.data.data.radiologists != null ||
            response.data.data.radiologists != undefined) &&
          response.data.data.radiologists.length > 0
        ) {
          const radiologistList = response.data.data.radiologists;
          const providerList = response.data.data.providers;

          providerList.forEach((provider) => {
            tempRadiologistList.push({
              key: "F" + provider.id,
              text:
                provider.qcType === ""
                  ? provider.name
                  : provider.qcType + " - " + provider.name,
            });
          });

          radiologistList.forEach((provider) => {
            tempRadiologistList.push({
              key: "R" + provider.id,
              text:
                provider.qcType === ""
                  ? provider.firstName + " " + provider.lastName
                  : provider.qcType +
                    " - " +
                    provider.firstName +
                    " " +
                    provider.lastName,
            });
          });
        }

        if (tempRadiologistList.length == 0) {
          tempRadiologistList.push({
            key: "0",
            text: "Providers not found.",
          });
        }
        setLoading(false);
        setClientProvidersList(tempRadiologistList);
        setOriginalList(tempRadiologistList);
      } else {
        setLoading(false);
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.ALERT_MODAL;
          newItem.heading = "Error";
          newItem.description = t("string-literals.error-msg");
          return newItem;
        });
      }
    } catch (e) {
      setLoading(false);
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Error";
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  };

  const handleFilterChange = (event, data) => {
    if (data != null && data != undefined) data = data.trim();
    const inputValue = data;
    setFilter(inputValue);

    // Filter the original list based on the filter value
    const filteredResults = originalList.filter((item) =>
      item.text.toLowerCase().includes(inputValue.toLowerCase())
    );

    // Set the filtered results to the state
    setClientProvidersList(filteredResults);
  };

  return (
    <div
      className="custom-dropdown-list"
      style={{
        maxHeight: clientProvidersList.length > 3 ? "160px" : "unset",
        height: loading ? "160px" : "unset",
      }}
      ref={ref}
    >
      <div className="custom-dropdown-search-box">
        {!loading && (
          <TextField
            label=""
            placeholder="Search..."
            styles={searchInputStyle}
            value={filterValue}
            onClick={(ev) => {
              ev.stopPropagation();
              console.log(ev);
            }}
            onChange={(ev, value) => {
              ev.stopPropagation();
              handleFilterChange(ev, value);
            }}
            iconProps={searchIcon}
            autoFocus={true}
          />
        )}
      </div>
      <div
        style={{
          alignItems:
            !loading && clientProvidersList.length != 0
              ? "flex-start"
              : "center",
        }}
        className="custom-drodown-list-container assign-dropdown-modal-scroll-light"
      >
        {loading ? (
          <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
        ) : clientProvidersList.length > 0 ? (
          <>
            {clientProvidersList.map((ele, index) => {
              return (
                ele.key[0] == "R" && (
                  <div
                    onClick={() => {
                      props.handleOnSelect(ele.text, ele.key);
                    }}
                    key={index}
                    className="custom-dropdown-list-item"
                  >
                    {/* {ele.key[0] == "R" && (
                  <div
                    className="active-circle"
                    // style={{
                    //   background: getRadiologistStatusColor(ele.activeStatus),
                    // }}
                  ></div>
                )} */}
                    {ele.key[0] == "R" && (
                      <span style={{ width: "125px", wordWrap: "break-word" }}>
                        {ele.text}
                      </span>
                    )}
                  </div>
                )
              );
            })}
            <div
              style={{ width: "100%", height: "2px", borderTop: BORDER.TAB }}
            ></div>
            {clientProvidersList.map((ele, index) => {
              return (
                ele.key[0] !== "R" && (
                  <div
                    onClick={() => {
                      if (ele.disabled) {
                        return;
                      }
                      props.handleOnSelect(ele.text, ele.key);
                    }}
                    key={index}
                    className={`custom-dropdown-list-item ${
                      ele.disabled ? "custom-dropdown-list-item-disabled" : ""
                    }`}
                  >
                    {ele.text}
                  </div>
                )
              );
            })}
          </>
        ) : (
          <div className="custom-dropdown-list-item">No record found</div>
        )}
      </div>
    </div>
  );
};
